import { Link } from 'react-router-dom';
import ContentLayout from '../../layout/contentLayout';
import styles from './scss/apppush.module.scss';
import WorktualDropdown from '../../components/custom_components/WroktualDropdown';
import { assets } from '../../styles/assets/assets';


const AppPush = () => {
    const options = [
        {
            label: 'One', value: 'one'
        }
    ]
    return (
        <ContentLayout noPaddingBlock={true}>
            <div className='breadcrumbs'>
                <ol>
                    <li>
                        <Link to=''>Campaign Name</Link>
                    </li>
                    <li>Email </li>
                </ol>
            </div>
            <div className={styles.inappsec}>
                <div className={styles.mdflefts}>
                    <p>Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed</p>
                    <div className={styles.searchset}>
                        <input type="text" name="" id="" placeholder='Ask to edit' />
                        <img className={styles.searchlt} src={assets.search_icon} alt="search_icon" />
                        <img className={styles.closeic} src={assets.multi_close} alt="multi_close" />
                    </div>
                </div>
                <div className={styles.mdfrights}>
                    <div className={styles.headertxtgrp}>
                        <div className={styles.headerlefts}>
                            <button className={`${styles.tabbtn} ${styles.activetbbtn}`}>Android</button>
                            <button className={`${styles.tabbtn}`}>iOS</button>
                        </div>
                        <div className={styles.headerrights}>
                            <p>A/B Test:</p>
                            <div className={styles.dropmenu}>
                                <WorktualDropdown onChange={() => { }} options={options}>
                                    <button className='cancelbtn'>Type A <img src={assets.chevrondown_icon} alt="chevrondown_icon" /></button>
                                </WorktualDropdown>
                            </div>
                        </div>
                    </div>
                    <div className={styles.prevsec}>
                        <div className={styles.previewshowsec}>
                            <div className={`${styles.mobilelayoutviewsec} ${styles.mobilelayoutapppushnotify} ${false ? styles.lockscreenandroid : styles.lockscreeniphone} `}>
                                <div className={styles.bodywrapper}>
                                    <div className={styles.pushnotifications}>
                                        <img className={styles.notifylogo} src={assets.notify_logo} alt="notifylogo" />
                                        <div className={styles.pushnotifycenter}>
                                            <p className={styles.notifytxt}>
                                              gdfgdfgdfdf
                                            </p>
                                        </div>
                                        <div className={styles.notifyaccord}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
                                                <path d="M1.82471 4.57617L6.80101 9.55247L11.7773 4.57617" stroke="#1A1C19" stroke-width="1.45142" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.btnsec}>
                            <button className='cancelbtn'>Cancel</button>
                            <button className='primarybtn'>Publish</button>
                        </div>
                    </div>
                </div>
            </div>
        </ContentLayout>
    )
}

export default AppPush
